export enum TokenType {
  Okta = 1,
  Rocketlane,
  External,
  Cognito,
}
type Epoc = number;

export enum TokenLinkType {
  AccountSignUp = 'ACCOUNT_SIGNUP',
  AccountForgot = 'ACCOUNT_FORGOT',
  AccountInvitation = 'ACCOUNT_INVITATION',
  ForgotPassword = 'FORGOT_PASSWORD',
}

export enum PermissionType {
  UserOtp = 'USER:OTP',
}

type ActionType =
  | 'MARK_TODO'
  | 'MARK_IN_PROGRESS'
  | 'MARK_COMPLETED'
  | 'MARK_BLOCKED'
  | 'APPROVE_REQUEST';

type Scope = PermissionType.UserOtp | `TASK:${ActionType}`;

interface TokenDecoded {
  accountId: number;
  emailId: string;
  exp: Epoc;
  iat: Epoc;
  iss: 'rocketlane.com';
  jti: string;
  linkType: TokenLinkType;
  permission: PermissionType;
  scopes: Scope[];
}
export interface TokenDecodedExtended extends TokenDecoded {
  email?: string;
  name?: string;
}
export type TokenMeta = {
  decoded: TokenDecodedExtended | null;
  isExpired: boolean;
};
export enum TokenErrorStatus {
  Expired = 'expired',
  Invalid = 'invalid',
  AlreadyCompleted = 'alreadyCompleted',
}
export interface LoginWidgetLinks {
  forgotPasswordUrl: string;
  loginUrl: string;
  postLoginRedirectUri: string;
  postLogoutRedirectUri: string;
  supportEmail: string;
}
